export function vocabularyGrade(card = {}) {
  if (card.completionReason === 'complete') return 5;
  return Math.max(0, Math.min(5, Math.floor(Number(card.grade) || 0)));
}

// A terminal reason describes how study ended; it must not promote the score
// or the learning grade just to display the matching existing graduation stamp.
export function vocabularyGraduationType(card = {}) {
  if (card.completionReason === 'already_known') return 'early';
  if (card.completionReason === 'user_canceled') return 'manual';
  if (vocabularyGrade(card) === 5) return 'score';
  return null;
}

export function buildVocabularyProgressCounts(cards = []) {
  return cards.reduce((counts, card) => {
    if (card.completionReason === 'user_canceled') return counts;
    const grade = vocabularyGrade(card);
    if (card.completionReason === 'already_known' || grade === 5) counts.completed += 1;
    else if (grade === 4) counts.testing += 1;
    else counts.practicing += 1;
    counts.total += 1;
    return counts;
  }, { practicing: 0, testing: 0, completed: 0, total: 0 });
}
